
// Orcamento.jsx — mantenha este arquivo na pasta original do projeto.

import { useState, useEffect, useContext } from 'react';

import { MyContext } from './context/UserProvider';

import { FaTrashAlt, FaWhatsapp } from 'react-icons/fa';

import { useNavigate } from 'react-router-dom';

import ImageWithLoader from '../layout/ImageWithLoader';

export default function Orcamento() {

  const [itensOrcamento, setItensOrcamento] = useState([]);

  const {
    setShowOrcamento, animateExitOrcamento, setAnimateExitOrcamento,
    setOpcaoDeParcela, opcaoDeParcela, setShowCheckoutPayment,
    orcamentosSelecionados, setOrcamentosSelecionados
  } = useContext(MyContext);

  const [hover, setHover] = useState(false);
  const [valorTotal, setValorTotal] = useState(0);
  const [tamanhosPorProduto, setTamanhosPorProduto] = useState({});
  const [salvandoTamanho, setSalvandoTamanho] = useState(null);
  const [erroTamanho, setErroTamanho] = useState({});
  const [selecaoPendente, setSelecaoPendente] = useState(null);
  const navigate = useNavigate();

  // Itens efetivamente escolhidos para a compra.
  const itensSelecionados = itensOrcamento.filter((item) =>
    orcamentosSelecionados.includes(Number(item.orcamento_id))
  );

  const quantidadeSelecionada = itensSelecionados.length;

  // Soma somente os preços confirmados pelo backend.
  // O valor definitivo continua sendo calculado no servidor.
  const valorSelecionado = itensSelecionados.reduce((total, item) => {
    const preco = Number(item.orcamento_preco);

    return total + (
      Number.isFinite(preco) ? Math.round(preco * 100) : 0
    );
  }, 0) / 100;

  const alternarSelecao = (orcamentoId, marcado) => {
    const id = Number(orcamentoId);

    if (!Number.isSafeInteger(id) || id <= 0) return;

    setOrcamentosSelecionados((anteriores) => {
      if (marcado) {
        return [...new Set([...anteriores, id])];
      }

      return anteriores.filter((atual) => Number(atual) !== id);
    });
  };


  // Layout de referência com 720px no desktop; largura total em telas menores.

  const [panelWidth, setPanelWidth] = useState(() => {

    if (typeof window === 'undefined') return '720px';

    return window.innerWidth < 720 ? '100%' : '720px';

  });

  useEffect(() => {

    const onResize = () => setPanelWidth(window.innerWidth < 720 ? '100%' : '720px');

    window.addEventListener('resize', onResize);

    return () => window.removeEventListener('resize', onResize);

  }, []);

  useEffect(() => {
    setAnimateExitOrcamento(false);
    getOrcamentoRoyal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {

    // enquanto o painel estiver montado, bloqueia o scroll do body para evitar scroll da página principal

    const prev = document.body?.style?.overflow;

    try { document.body.style.overflow = 'hidden'; } catch (e) { /* ambiente sem DOM */ }

    return () => { try { document.body.style.overflow = prev || ''; } catch (e) { } };

  }, []);

  const close = () => {

    // dispara animação de saída e fecha após ela terminar

    setAnimateExitOrcamento(true);

    setTimeout(() => {

      setShowOrcamento(false);

      setAnimateExitOrcamento(false);

    }, 500);

  };

  const deleteFromOrcamentoRoyal = (produto_id, orcamento_id) => {

    const usuario = JSON.parse(localStorage.getItem('usuario'));

    const usuario_id = usuario?.usuario_id;

    if (!usuario_id) {

      navigate('/CadastroScreen');

      return;

    }

    const toSearch = { usuario_id, produto_id, orcamento_id };

    const apiBase = process.env.REACT_APP_API_URL;

    fetch(`${apiBase}/api/deleteFromOrcamentoRoyal`, {

      method: 'POST',

      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },

      body: JSON.stringify(toSearch),

    })

      .then((r) => r.json())

      .then((json) => {

        getOrcamentoRoyal();

      })

      .catch((err) => console.error(err));

  };

  // Consulta os mesmos tamanhos ativos apresentados em Produto.js.
  // Cada produto pode ter medidas diferentes; não inventamos opções.
  const carregarTamanhos = async (orcamentos) => {
    const produtos = [...new Set(
      (orcamentos || [])
        .map((item) => Number(item.produto_id))
        .filter((id) => Number.isSafeInteger(id) && id > 0)
    )];
    const apiBase = process.env.REACT_APP_API_URL;

    await Promise.all(produtos.map(async (produtoId) => {
      try {
        const response = await fetch(`${apiBase}/api/getInfoProduto`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ produto_id: produtoId }),
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const produto = await response.json();
        const tamanhos = Array.isArray(produto?.tamanhos)
          ? [...new Set(produto.tamanhos.map(Number).filter(
            (v) => Number.isSafeInteger(v) && v > 0
          ))]
          : [];
        setTamanhosPorProduto((prev) => ({ ...prev, [produtoId]: tamanhos }));
      } catch (error) {
        console.error('Erro ao consultar tamanhos do produto:', produtoId, error);
      }
    }));
  };

  // Solicita ao backend o novo tamanho e apresenta apenas o preço confirmado pela API.
  const atualizarTamanho = async (item, tamanhoCm) => {
    const tamanhosPermitidos = tamanhosPorProduto[item.produto_id] || [];
    const tamanho = Number(tamanhoCm);
    if (!tamanhosPermitidos.includes(tamanho)) return;
    if (salvandoTamanho !== null) return;
    const metrosAtuais = Number(item.metros);
    if (Math.round(metrosAtuais * 100) === tamanho) return;

    const orcamentoId = Number(item.orcamento_id);
    if (!Number.isSafeInteger(orcamentoId) || orcamentoId <= 0) return;
    setSalvandoTamanho(orcamentoId);
    setSelecaoPendente({ orcamentoId, tamanho });
    setErroTamanho((prev) => ({ ...prev, [orcamentoId]: '' }));

    let salvoNoBackend = false;
    try {
      const apiBase = process.env.REACT_APP_API_URL;
      const usuario = JSON.parse(localStorage.getItem('usuario') || '{}');
      const authToken = usuario?.auth_token;
      if (!authToken) {
        throw new Error('Sua sessão expirou. Faça login novamente.');
      }
      const response = await fetch(`${apiBase}/api/updateMetrosFromOrcamentoRoyal`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({ orcamento_id: orcamentoId, metros: tamanho / 100 }),
      });
      const resultado = await response.json().catch(() => null);
      if (!response.ok || resultado?.success !== true) {
        throw new Error(resultado?.error || resultado?.message || `HTTP ${response.status}`);
      }

      const atualizado = resultado.updated;
      if (
        Number(atualizado?.orcamento_id) !== orcamentoId ||
        Math.round(Number(atualizado?.metros) * 100) !== tamanho ||
        atualizado?.orcamento_preco == null ||
        !Number.isFinite(Number(atualizado.orcamento_preco))
      ) {
        throw new Error('A API não confirmou a nova medida e o preço.');
      }
      salvoNoBackend = true;

      // Atualiza a seleção e o preço do item somente com dados calculados no servidor.
      setItensOrcamento((anteriores) => anteriores.map((atual) =>
        Number(atual.orcamento_id) === orcamentoId
          ? { ...atual, metros: atualizado.metros, orcamento_preco: atualizado.orcamento_preco }
          : atual
      ));

      // Reconsulta o valor total calculado pelo backend; nunca calcula no frontend.
      await getOrcamentoRoyal(true);
    } catch (error) {
      console.error('Erro ao atualizar o tamanho:', error);
      setErroTamanho((prev) => ({
        ...prev,
        [orcamentoId]: salvoNoBackend
          ? 'Medida salva, mas não foi possível atualizar o total. Reabra o orçamento.'
          : (error.message || 'Não foi possível atualizar o tamanho.'),
      }));
    } finally {
      setSelecaoPendente(null);
      setSalvandoTamanho(null);
    }
  };

  const getOrcamentoRoyal = (propagarErro = false) => {

    const usuario = JSON.parse(localStorage.getItem('usuario'));

    const usuario_id = usuario?.usuario_id;

    const toSearch = { usuario_id };

    const apiBase = process.env.REACT_APP_API_URL;

    return fetch(`${apiBase}/api/getOrcamentoRoyal`, {

      method: 'POST',

      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },

      cache: 'no-store',

      body: JSON.stringify(toSearch),

    })

      .then((response) => {

        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

        return response.json();

      })

      .then((json) => {

        if (!json?.success || !Array.isArray(json.orcamentos) ||
          json.valor_total == null || !Number.isFinite(Number(json.valor_total))) {
          throw new Error(json?.message || 'A API não retornou os valores atualizados.');
        }


        setItensOrcamento(json.orcamentos);
        setValorTotal(Number(json.valor_total));

        // Remove da seleção IDs que não existem mais no carrinho.
        setOrcamentosSelecionados((anteriores) =>
          anteriores.filter((id) =>
            json.orcamentos.some(
              (item) => Number(item.orcamento_id) === Number(id)
            )
          )
        );

        carregarTamanhos(json.orcamentos);


      })

      .catch((error) => {
        console.error('Erro na requisição:', error);
        if (propagarErro) throw error;
      });

  };

  // --- ADIÇÕES MÍNIMAS PARA SOMAR OS PREÇOS ---

  // <-- ALTERAÇÃO: formatBR agora adiciona separador de milhares ('.') e vírgula como decimal

  const formatBR = (v) => {

    const n = Number(v) || 0;

    const sign = n < 0 ? '-' : '';

    const abs = Math.abs(n);

    const [intPart, decPart] = abs.toFixed(2).split('.');

    const intWithDots = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    return `${sign}${intWithDots},${decPart}`;

  };

  // --- FIM DAS ADIÇÕES ---

  // ----------------- NOVAS FUNÇÕES PARA WHATSAPP -----------------

  // Monta a mensagem com quebras e campos fáceis de ler

  const buildWhatsAppMessage = () => {

    if (!itensOrcamento || itensOrcamento.length === 0) return '';

    const usuario = JSON.parse(localStorage.getItem('usuario')) || {};

    const lines = [];

    lines.push('📋 *Orçamento*');

    lines.push('');

    if (usuario.nome || usuario.usuario_nome) lines.push(`Cliente: ${usuario.nome || usuario.usuario_nome}`);

    if (usuario.usuario_telefone) lines.push(`Telefone: ${usuario.usuario_telefone}`);

    lines.push(`Data: ${new Date().toLocaleString()}`);

    lines.push('');

    lines.push('--- Itens ---');

    itensOrcamento.forEach((item, i) => {

      lines.push(`${i + 1}) ${item.produto_nome || 'Produto'}`);

      if (item.categoria_nome) lines.push(`   Categoria: ${item.categoria_nome}`);

      if (item.metros !== undefined && item.metros !== null && String(item.metros).trim() !== '') lines.push(`   Tamanho: ${item.metros} m`);

      lines.push(`   Preço: R$ ${formatBR(item?.orcamento_preco)}`);

      if (item.produto_imagem_url) lines.push(`   Imagem do produto: ${item.produto_imagem_url}`);

      lines.push(''); // linha em branco entre itens

    });

    lines.push(`*Total: R$ ${formatBR(valorTotal)}*`);

    lines.push('');

    lines.push('Observações: ');

    lines.push('');

    lines.push('Aguardo retorno para confirmar o pedido. Obrigado!');

    return lines.join('\n');

  };

  // Abre o WhatsApp com a mensagem montada. Se quiser abrir em conversa com número específico,

  // chame sendOrcamentoToWhatsApp('5511999999999') — formato internacional recomendado (sem +).

  const sendOrcamentoToWhatsApp = (phoneNumber) => {

    if (!itensOrcamento || itensOrcamento.length === 0) {

      alert('Seu orçamento está vazio. Adicione itens antes de enviar para o WhatsApp.');

      return;

    }

    const message = buildWhatsAppMessage();

    if (!message) {

      alert('Erro ao montar a mensagem do orçamento.');

      return;

    }

    const encoded = encodeURIComponent(message);

    const base = phoneNumber ? `https://wa.me/${String(phoneNumber).replace(/\D/g, '')}` : 'https://wa.me/';

    // abre em nova aba/janela

    window.open(`${base}?text=${encoded}`, '_blank');

  };

  // ----------------- FIM NOVAS FUNÇÕES -----------------

  const itemImageStyle = {

    width: '100%',

    height: 'auto',
    maxHeight: 'min(34dvh, 340px)',

    objectFit: 'contain',

    borderRadius: 0,

    display: 'block',

  };

  const resumoFinanceiro = (
    <>
      {/* Valor total do orçamento */}

      <div
        style={{
          borderTop: '1px solid #eee',
          paddingTop: 12,
          marginTop: 12,
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          flexWrap: 'wrap',
        }}
      >

        <p style={{ margin: 0, fontSize: 14 }}>
          Total selecionado:
        </p>

        <p
          style={{
            margin: 0,
            fontSize: 16,
            fontWeight: 700,
          }}
        >
          R$ {formatBR(valorSelecionado)}
        </p>

      </div>

      {/* Parcelamento e prévia Pix */}

      <div
        style={{
          marginTop: 14,
          padding: 14,
          border: '1px solid #ebe4dc',
          borderRadius: 10,
          backgroundColor: '#fbfaf8',
          boxSizing: 'border-box',
        }}
      >

        <label
          htmlFor="parcelas-carrinho"
          style={{
            display: 'block',
            marginBottom: 8,
            fontSize: 13,
            fontWeight: 600,
            color: '#382e27',
          }}
        >
          Parcelamento no cartão
        </label>

        <select
          id="parcelas-carrinho"
          value={
            [1, 2, 3, 4, 5, 6].includes(Number(opcaoDeParcela))
              ? Number(opcaoDeParcela)
              : 6
          }
          onChange={(e) =>
            setOpcaoDeParcela(Number(e.target.value))
          }
          style={{
            width: '100%',
            minWidth: 0,
            padding: '11px 12px',
            border: '1px solid #ddd4ca',
            borderRadius: 8,
            backgroundColor: '#fff',
            color: '#382e27',
            fontSize: 14,
            cursor: 'pointer',
            boxSizing: 'border-box',
          }}
        >

          {[1, 2, 3, 4, 5, 6].map((quantidade) => (

            <option
              key={quantidade}
              value={quantidade}
            >
              {quantidade}x de R$ {
                formatBR(valorSelecionado / quantidade)
              }
            </option>

          ))}

        </select>

        <p
          style={{
            fontSize: 11,
            color: '#8a8076',
            margin: '7px 0 0',
          }}
        >
          Valores estimados. Parcelamento confirmado no Asaas.
        </p>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 8,
            marginTop: 14,
            paddingTop: 12,
            borderTop: '1px solid #e9e3dc',
          }}
        >

          <span
            style={{
              fontSize: 13,
              color: '#5f4738',
            }}
          >
            Pix à vista

            <strong
              style={{
                marginLeft: 7,
                fontSize: 15,
              }}
            >
              R$ {formatBR(
                Math.round(
                  Math.round(Number(valorSelecionado) * 100) * 0.9
                ) / 100
              )}
            </strong>
          </span>

          <span
            style={{
              padding: '5px 8px',
              borderRadius: 6,
              backgroundColor: '#f2e8d9',
              color: '#5f4738',
              fontSize: 11,
              fontWeight: 700,
            }}
          >
            10% OFF
          </span>

        </div>

      </div>
    </>
  );

  return (

    <div translate="no" style={{ position: 'relative', width: '100%', height: '100%' }}>

      {/* Backdrop: aparece imediatamente (sem animação). Fica atrás do painel até a animação de saída terminar. */}

      <div

        onClick={close}

        style={{

          position: 'fixed',

          inset: 0,

          transition: 'background-color 600ms ease, backdrop-filter 600ms ease, opacity 600ms ease',

          backdropFilter: 'blur(4px)',

          backgroundColor: 'rgba(0,0,0,0.35)',

          zIndex: 1001,

        }}

      />

      {/* Painel (drawer) ANIMADO À DIREITA */}

      <div

        role="dialog"

        aria-modal="true"

        className="orcamento-panel"

        style={{

          position: 'fixed',

          right: 0,

          left: panelWidth === '100%' ? 0 : 'auto',

          top: 0,

          zIndex: 1002,

          width: panelWidth,

          maxWidth: panelWidth === '100%' ? '100%' : '720px',

          height: '100vh',

          backgroundColor: '#fff',

          overflow: 'hidden',

          boxShadow: '-20px 0 40px rgba(0,0,0,0.2)',

          display: 'flex',

          flexDirection: 'column',

          animation: animateExitOrcamento ? 'slideOutPanel 0.45s ease forwards' : 'slideInPanel 0.45s ease forwards',

          boxSizing: 'border-box',

        }}

        onWheel={(e) => e.stopPropagation()}

      >

        {/* Header */}

        <div

          style={{

            display: 'flex',

            flexDirection: 'row',

            backgroundColor: hover ? 'white' : 'black',

            height: 48,

            alignItems: 'center',

            cursor: 'pointer',

            padding: '0 12px',

            flexShrink: 0,

          }}

          onMouseEnter={() => setHover(true)}

          onMouseLeave={() => setHover(false)}

          onClick={close}

        >

          <p style={{ color: hover ? 'black' : '#fff', fontSize: 18, fontWeight: 'bold', margin: 0 }}>X</p>

          <h1 style={{ fontWeight: 'bold', color: hover ? 'black' : '#fff', margin: '0 0 0 12px', flex: 1, fontSize: 16 }}>Orçamento</h1>

        </div>

        {/* Conteúdo */}

        <div

          className="orcamento-content"

          style={{

            padding: 16,

            paddingBottom: 16,

            flex: 1,

            minHeight: 0,

            display: 'flex',

            flexDirection: 'column',

          }}

        >

          {itensOrcamento.length > 0 ? (

            <>

              <ul
                className="orcamento-list"
                style={{
                  listStyle: 'none',
                  padding: 0,
                  margin: 0,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 12,
                }}
              >

                {itensOrcamento.map((item, index) => (

                  <li

                    key={`${item.produto_id ?? item.orcamento_id ?? ''}-${index}`}

                    className="orcamento-item"

                    style={{

                      position: 'relative',

                      display: 'flex',

                      gap: 12,

                      alignItems: 'center',

                      paddingBottom: 12,

                      borderBottom: '1px solid #eee',

                      flexWrap: 'wrap',

                    }}


                  >

                    <label
                      style={{
                        position: 'absolute',
                        top: 8,
                        left: 8,
                        zIndex: 4,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 6,
                        padding: '6px 8px',
                        background: 'rgba(255,255,255,0.96)',
                        border: '1px solid #e7e0d7',
                        borderRadius: 6,
                        cursor: 'pointer',
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={orcamentosSelecionados.includes(
                          Number(item.orcamento_id)
                        )}
                        onChange={(e) =>
                          alternarSelecao(
                            item.orcamento_id,
                            e.target.checked
                          )
                        }
                        disabled={salvandoTamanho !== null}
                        style={{
                          width: 19,
                          height: 19,
                          margin: 0,
                          accentColor: '#634a3b',
                          cursor: 'pointer',
                        }}
                      />
                      <span style={{
                        fontSize: 12,
                        color: '#382e27',
                      }}>
                        {orcamentosSelecionados.includes(
                          Number(item.orcamento_id)
                        ) ? 'Selecionado' : 'Selecionar'}
                      </span>
                    </label>

                    <ImageWithLoader


                      src={item.produto_imagem_url}

                      alt={item.produto_nome}

                      style={{
                        ...itemImageStyle,
                        display: 'block',
                        opacity: orcamentosSelecionados.includes(
                          Number(item.orcamento_id)
                        ) ? 1 : 0.45,
                        transition: 'opacity 0.2s ease',
                      }}

                    />

                    <div
                      className="orcamento-item-content"
                      style={{
                        flex: 1,
                        minWidth: 0,
                        opacity: orcamentosSelecionados.includes(
                          Number(item.orcamento_id)
                        ) ? 1 : 0.55,
                        transition: 'opacity 0.2s ease',
                      }}
                    >

                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          gap: 8,
                        }}
                      >

                        <p
                          style={{
                            fontSize: 16,
                            fontWeight: 600,
                            margin: 0,
                            wordBreak: 'break-word',
                            overflowWrap: 'anywhere',
                          }}
                        >
                          {item.produto_nome}
                        </p>

                        <FaTrashAlt

                          onClick={() =>
                            deleteFromOrcamentoRoyal(
                              item.produto_id,
                              item.orcamento_id
                            )
                          }

                          style={{
                            cursor: 'pointer',
                            flexShrink: 0,
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            zIndex: 2,
                          }}

                        />

                      </div>

                      <p
                        style={{
                          margin: '4px 0',
                          fontSize: 13,
                          color: '#666',
                          wordBreak: 'break-word',
                        }}
                      >
                        {item.categoria_nome}
                      </p>

                      {/* Metragem com as mesmas opções do Produto.js */}

                      {(() => {

                        const tamanhos =
                          tamanhosPorProduto[item.produto_id] || [];

                        const metrosAtuais = Number(item.metros);

                        if (tamanhos.length === 0) {

                          return (

                            <p
                              style={{
                                margin: '8px 0',
                                fontSize: 14,
                                color: '#333',
                              }}
                            >
                              Tamanho: {Number.isFinite(metrosAtuais)
                                ? metrosAtuais.toLocaleString('pt-BR', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                                : '—'} m
                            </p>

                          );

                        }

                        return (

                          <div style={{ margin: '12px 0' }}>

                            <p
                              style={{
                                margin: '0 0 9px',
                                fontSize: 14,
                                color: '#333',
                                fontWeight: 500,
                              }}
                            >
                              Tamanho total
                            </p>

                            <div
                              style={{
                                display: 'grid',
                                gridTemplateColumns:
                                  'repeat(2, minmax(0, 1fr))',
                                gap: 8,
                              }}
                            >

                              {tamanhos.map((tamanhoCm) => {

                                const selecionado =
                                  (selecaoPendente?.orcamentoId === Number(item.orcamento_id)
                                    ? selecaoPendente.tamanho
                                    : Math.round(metrosAtuais * 100)) === tamanhoCm;

                                const ocupado =
                                  salvandoTamanho !== null;

                                return (

                                  <button

                                    key={tamanhoCm}

                                    type="button"

                                    disabled={ocupado}

                                    onClick={() =>
                                      atualizarTamanho(item, tamanhoCm)
                                    }

                                    style={{

                                      minHeight: 42,

                                      padding: '9px 8px',

                                      borderRadius: 7,

                                      border: selecionado
                                        ? '1.5px solid #5f4738'
                                        : '1px solid #ddd5cc',

                                      backgroundColor: selecionado
                                        ? '#f1ece6'
                                        : '#fff',

                                      color: '#3b3028',

                                      fontSize: 13,

                                      fontWeight: selecionado
                                        ? 600
                                        : 400,

                                      textAlign: 'center',

                                      cursor: ocupado
                                        ? 'wait'
                                        : 'pointer',

                                      opacity: ocupado ? 0.7 : 1,

                                      transition:
                                        'background-color 0.2s ease',

                                      boxSizing: 'border-box',

                                    }}

                                  >

                                    {(tamanhoCm / 100).toLocaleString(
                                      'pt-BR',
                                      {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }
                                    )} m

                                  </button>

                                );

                              })}

                            </div>

                            {erroTamanho[item.orcamento_id] && (

                              <p
                                style={{
                                  color: '#b91c1c',
                                  fontSize: 12,
                                  margin: '8px 0 0',
                                }}
                              >
                                {erroTamanho[item.orcamento_id]}
                              </p>

                            )}

                          </div>

                        );

                      })()}

                      <p
                        style={{
                          margin: '8px 0',
                          fontSize: 14,
                          color: '#333',
                        }}
                      >
                        Preço: R$ {formatBR(item?.orcamento_preco)}
                      </p>

                    </div>

                  </li>

                ))}

              </ul>

              {itensOrcamento.length > 1 && resumoFinanceiro}

            </>

          ) : (

            <div
              style={{
                padding: 12,
                display: 'flex',
                flexDirection: 'column',
              }}
            >

              <p style={{ marginBottom: 0 }}>
                Escolha o sofá que mais combine com seu ambiente
              </p>

              <p
                style={{
                  marginTop: 0,
                  fontWeight: 'bold',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  navigate('/produtos/1');
                  close();
                }}
              >
                Clique aqui!
              </p>

            </div>

          )}


        </div>

        {/* Ações do orçamento */}

        <div
          style={{
            paddingTop: 12,
            position: 'relative',
            flexShrink: 0,
            paddingLeft: 16,
            paddingRight: 16,
            backgroundColor: '#fff',
            paddingBottom: 12,
            borderTop: '1px solid #eee',
            zIndex: 3,
          }}
        >

          {itensOrcamento.length > 0 && (
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: 8,
              fontSize: 14,
              color: '#333',
            }}>
              <span>Total selecionado</span>
              <strong>R$ {formatBR(valorSelecionado)}</strong>
            </div>
          )}

          <div
            className="orcamento-actions"
            style={{
              display: 'flex',
              flexWrap: 'nowrap',
              alignItems: 'stretch',
              gap: 0,
            }}
          >

            <button
              type="button"
              disabled={quantidadeSelecionada === 0 || salvandoTamanho !== null}
              onClick={() => {
                if (!quantidadeSelecionada || salvandoTamanho !== null) return;
                setShowCheckoutPayment(true);
              }}
              style={{
                flex: 1,
                padding: '10px 12px',
                backgroundColor: '#000',
                color: '#fff',
                borderRadius: 6,
                border: 'none',
                cursor: 'pointer',
                minHeight: 36,
                opacity: quantidadeSelecionada === 0 || salvandoTamanho !== null ? 0.45 : 1,
              }}
            >
              Concluir Orçamento
            </button>

            <button
              type="button"
              disabled={quantidadeSelecionada === 0 || salvandoTamanho !== null}
              onClick={() => {
                if (!quantidadeSelecionada || salvandoTamanho !== null) return;
                setShowCheckoutPayment(true);
              }}
              style={{
                width: 42,
                minWidth: 42,
                minHeight: 36,
                padding: 0,
                backgroundColor: '#25D366',
                color: '#fff',
                borderRadius: 6,
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginLeft: 6,
                opacity: quantidadeSelecionada === 0 || salvandoTamanho !== null ? 0.45 : 1,
              }}
            >
              <FaWhatsapp />
            </button>

          </div>

        </div>

        {/* Animações e estilos responsivos */}

        <style>{`

          @keyframes slideInPanel {
            from { transform: translateX(100%); }
            to { transform: translateX(0%); }
          }

          @keyframes slideOutPanel {
            from { transform: translateX(0%); }
            to { transform: translateX(100%); }
          }

          .orcamento-panel {
            overflow: hidden;
            box-sizing: border-box;
            container-type: inline-size;
            container-name: orcamento;
          }

          /* Mesma distribuição do esboço: 300px de imagem e resumo à direita. */
          .orcamento-item--destaque {
            grid-template-columns: minmax(0, 300px) minmax(0, 1fr);
            gap: 14px;
          }

          /* No celular, empilha para evitar texto e botões comprimidos. */
          @container orcamento (max-width: 620px) {
            .orcamento-item--destaque {
              grid-template-columns: minmax(0, 1fr);
            }

            .orcamento-item--destaque > :first-child {
              max-height: 300px;
              max-width: 100%;
            }
          }

          .orcamento-content {
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
            scrollbar-width: none;
            padding-bottom: 96px;
          }

          .orcamento-content::-webkit-scrollbar {
            display: none;
          }

          .orcamento-list,
          .orcamento-item {
            box-sizing: border-box;
          }

          .orcamento-item-content p,
          .orcamento-item-content div {
            word-break: break-word;
            overflow-wrap: anywhere;
          }

          @media (max-width: 940px) {
            .orcamento-actions {
              gap: 6px;
            }
          }

                    @media (max-width: 768px) {
            .orcamento-panel {
              width: 100vw !important;
              max-width: 100vw !important;
            }

            .orcamento-item {
              grid-template-columns: 1fr !important;
              gap: 12px !important;
            }

            .orcamento-item-content {
              min-width: 0;
            }
          }

          @media (max-width: 480px) {
            .orcamento-actions {
              flex-direction: row;
            }
          }

        `}</style>

      </div>

    </div>

  );

}
